export const GET_ACCOUNT_DATA = "GET_ACCOUNT_DATA";
export const PAYMENT_HISTORY = "PAYMENT_HISTORY";
export const GET_PAYMENT_TYPE_DETAILS = "GET_PAYMENT_TYPE_DETAILS";
export const GET_HOW_IT_WORKS_CMS_DATA = "GET_HOW_IT_WORKS_CMS_DATA";
export const REMOVE_ACCOUNT_DATA = "REMOVE_ACCOUNT_DATA";
export const SUBSCRIBED = "SUBSCRIBED";
export const GET_IS_PRO_MEMBER = "GET_IS_PRO_MEMBER";
export const GET_ACCOUNT_DATA_LOADER = "GET_ACCOUNT_DATA_LOADER";
export const GET_ACCOUNT_LOADER = "GET_ACCOUNT_LOADER";
export const INITIAL_LOADER = "INITIAL_LOADER";
